enum BaseEventTypes {
	unsure = "Unsure",
	normal = "Normal",
}

export default BaseEventTypes;